import React from "react";
import { useProductTemplateAccessLevel } from "./product-template-access-level-ctx";
import { Stack, Tag } from "@shopify/polaris";

export default function ProductTemplateUserAccess({ template }) {
  const { refetch, ...ctx } = useProductTemplateAccessLevel() || {};

  if (!template || !template.id || !ctx[template.id]) {
    return null;
  }

  const users = ctx[template.id];
  return (
    <Stack spacing="extraTight">
      {users.map((user, index) => (
        <Tag children={user} key={`${user}__${index}`} />
      ))}
    </Stack>
  );
}
